/* eslint-disable jsx-a11y/anchor-is-valid */

import LatestResearch from "./Home/LatestResearch";
import Forefront from "./Home/Forefront";
import Announcements from "./Home/Announcements";
import JoinChorusOne from "./Home/JoinChorusOne";
import Footer from "./Home/Footer";
import Hero from "./Home/Hero";

const SwapCard = ({ setShowModal }) => {
  return (
    <div className="overflow-hidden">
      <Hero setShowModal={setShowModal} />
      <Forefront />
      <LatestResearch />
      <Announcements />
      <JoinChorusOne />
      <Footer />
    </div>
  );
};

export default SwapCard;
